<template>
    <div class="dbverify">登录中，请稍后...</div>
</template>

<script>
import {checkClientlogin} from "@api/common"

export default {
    name:"dbverify",
    data(){
        return {
            tk:"", // token
        }
    },
    mounted(){
        // 验证登录
        this.checklogin();
    },
    methods:{
        // 验证登录
        checklogin(){
            let tk=this.getQueryVariable("token");// 获取token的值
            let to=this.getQueryVariable("page");// 进入页面
            if(tk){
                // 验证token是否有效
                checkClientlogin(tk).then(res=>{
                    // 如果登录成功
                    if(res.status==200){
                        let content=res.content;
                        // 更新用户信息
                        let user=content.user;
                        this.$store.commit("user",user);
                        // 更新内存token
                        this.$store.commit("token",user.token);
                        // 更新数据库信息
                        let dbList=content.db;
                        let dbgroup=dbList[Object.keys(dbList)[0]];
                        let databasesList=dbgroup.databasesList;
                        let db=databasesList[Object.keys(databasesList)[0]];

                        // 更新数据库信息
                        this.$store.commit('db',db);

                        //跳转页面
                        if(to){
                            to=decodeURIComponent(to);
                            this.$router.push({ name: to});
                        }else{
                            this.$router.push("/list/realTimeForm");
                        }

                    }else{
                        this.$message({
                            message:"登录失败",
                            type:"error",
                        });
                    }
                })
            }
        },
        
        // 获取请求参数
        getQueryVariable(variable){
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
            }
            return(false);
        }
    }
}
</script>

<style lang="scss">
.dbverify{
    position: absolute;
    margin: 40px auto;
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
}
</style>